const DB_NAME = 'roavyn-fishing-reports';
const DB_VERSION = 1;
const STORE_NAME = 'reports';

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        const store = database.createObjectStore(STORE_NAME, { keyPath: 'id' });
        store.createIndex('modifiedAt', 'modifiedAt');
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function runTransaction(mode, operation) {
  const database = await openDatabase();

  return new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, mode);
    const store = transaction.objectStore(STORE_NAME);
    const request = operation(store);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    transaction.oncomplete = () => database.close();
  });
}

export function saveReport(report) {
  return runTransaction('readwrite', (store) => store.put(report));
}

export function getReport(id) {
  return runTransaction('readonly', (store) => store.get(id));
}

export function getReports() {
  return runTransaction('readonly', (store) => store.getAll()).then((reports) =>
    reports.sort((a, b) => new Date(b.modifiedAt) - new Date(a.modifiedAt))
  );
}

export function deleteReport(id) {
  return runTransaction('readwrite', (store) => store.delete(id));
}

export async function requestPersistentStorage() {
  if (navigator.storage?.persist) {
    return navigator.storage.persist();
  }

  return false;
}